import React from 'react';
import Cut from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/cut.svg';
import CutGold from 'components/canvas/components/nodes/components/base-node/components/node-context-menu/icons/cut-gold.svg';
import Icon from 'components/canvas/components/icon';
import { useTranslation } from 'i18n';
import { useCanvasClipboardOperations } from 'state/canvas-clipboard';
import { useSelectedNodeOperations } from 'state/canvas/selected-node';
import { toast } from 'services/toast';
import { KonvaEventObject } from 'konva/lib/Node';
import { SurfaceNodeUnion } from 'graphql/types';

export interface CutIconProps {
  node?: SurfaceNodeUnion;
  isSelected?: boolean;
  onClick?: (event: KonvaEventObject<MouseEvent>) => void;
  width?: number;
  height?: number;
}

const defaultProps = {
  isSelected: false,
};

function CutIcon(props: CutIconProps) {
  const { t } = useTranslation();
  const { node } = props;
  const { addNodesForCutToClipboard } = useCanvasClipboardOperations();
  const { clearSelectedNode } = useSelectedNodeOperations();
  const [isSelected, setSelected] = React.useState<boolean>(false);

  const src = isSelected ? CutGold : Cut;

  function cutNode(node) {
    if (node) {
      toast.success(
        t(`Successfully added node {{name}} to clipboard.`, {
          replace: { name: node?.name || '' },
        }),
      );
      addNodesForCutToClipboard([node]);
      clearSelectedNode();
    }
  }

  function onClick(event) {
    event.cancelBubble = true;

    // I know :( but we wanna show user feedback when he clicks on icon
    if (node) {
      cutNode(node);
    }

    props.onClick && props.onClick(event);
  }

  return (
    <Icon
      {...props}
      onClick={onClick}
      src={src}
      onMouseOver={() => setSelected(true)}
      onMouseOut={() => setSelected(false)}
    />
  );
}

CutIcon.defaultProps = defaultProps;

export default CutIcon;
